<template>
  <form-select v-bind="props"
               :options="baseOptions"
               @update:modelValue="value => emit('update:modelValue', value)"/>
</template>

<script setup lang="ts">
import {useI18n} from "#imports";
const {t} = useI18n();
const props = withDefaults(defineProps<{}>(), {});
const emit = defineEmits(['update:modelValue']);

const baseOptions = [
  {value: 'm', text: t('label.male')},
  {value: 'f', text: t('label.female')},
];

</script>